import { CIActionBtnGroup, CIActionGuard, Checkbox, useUserPermission } from 'ccs-ui-components';
import { Dispatch, SetStateAction, useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

import { requiredAuthPermission } from '../../../../../../common/constants/UserPermissionConstants';
import ConfirmDialog from '../../../../../_components/confirm-dialog/ConfirmDialog';
import { IFieldDefRowItem } from '../../../../../models';

import classes from '../PatternRegistryForm.module.scss';

interface IRowItem {
  data: IFieldDefRowItem,
  deleteItem: (id: string) => void,
  editItem: (id: string) => void,
  disabled: boolean,
  isView: boolean,
  isEdit: boolean,
  setShowFieldDefInput: Dispatch<SetStateAction<boolean>>;
}

const FieldDefListRowItem = (props: IRowItem) => {
  const { t: translate } = useTranslation();
  const { data: { required, id, name, operator, value, contentType, conversionPattern }, deleteItem, editItem, disabled, isView, isEdit, setShowFieldDefInput } = props;

  const [showConfirmDialog, setShowConfirmDialog] = useState(false);

  const { permissionObject } = useUserPermission();

  /**
   * @method deleteHandler
   * @description Handler function for deleting a row item.
   */
  const deleteHandler = () => {
    setShowConfirmDialog(true);
  };

  /**
   * @method editHandler
   * @description Handler for editing the field definition.
   */
  const editHandler = () => {
    setShowFieldDefInput(true);
    editItem(id);
  };

  /**
   * @method onConfirmBtnDialogueHandler
   * @description Handler for confirming the button dialogue.
   */
  const onConfirmBtnDialogueHandler = () => {
    deleteItem(id);
  };

  return (
    <div className={classes['fd-list']} data-testid="pr-fd-list">
      <ConfirmDialog
        label={translate('pattern_registry_form.delete_msg')}
        show={showConfirmDialog}
        onHide={() => {
          setShowConfirmDialog(false);
        }}
        onConfirm={() => {
          onConfirmBtnDialogueHandler();
        }}
        btnContinueText={translate('pattern_registry_form.yes') ?? ''}
        btnCancelText={translate('pattern_registry_form.no') ?? ''}
      />
      <Row className={classes['list-body']} data-testid="pattern-list-item">
        <Col sm={10}>
          <Row>
            <Col sm={1} className={classes['pattern-name-wrapper']}>
              <span className={classes['cp-capsule-wrapped-title-tooltip']} title="Required">
                <Checkbox
                  checked={required}
                  disabled
                  data-testid="check-reqd"
                />
              </span>
            </Col>
            <Col sm={2} className={classes['pattern-name-wrapper']}>
              <span className={classes['cp-capsule-wrapped-title-tooltip']} title={name}>
                {name}
              </span>
            </Col>
            <Col sm={3} className={classes['pr-col-2-styling']}>
              <p>{operator}</p>
            </Col>
            <Col sm={2} className={classes['pattern-value-wrapper']}>
              <span className={classes['pattern-value-wrapper-tooltip']} title={value}>
                {value}
              </span>
            </Col>
            <Col sm={2} className={classes['pr-fd-type-styling']}>
              <p>{contentType}</p>
            </Col>
            <Col sm={2} className={classes['pattern-value-wrapper']}>
              <span className={`${classes['pattern-value-wrapper-tooltip']} ${classes['cp-conversion-pattern']}`} title={conversionPattern}>
                {conversionPattern}
              </span>
            </Col>
          </Row>
        </Col>
        <Col sm={2} className={classes['pr-cluster']}>
          {(!isView || isEdit) && (
            <CIActionBtnGroup buttons={[{ label: 'edit', key: 'editIcon', onClick: () => editHandler(), disabled, testId: 'pr-fd-edit-btn', show: CIActionGuard([requiredAuthPermission.CP.edit], permissionObject.permission) }, { label: 'delete', key: 'deleteIcon', onClick: () => deleteHandler(), disabled, testId: 'pr-fd-delete-btn', show: CIActionGuard([requiredAuthPermission.CP.edit], permissionObject.permission) }]} />)}
        </Col>
      </Row>
    </div>
  );
};

export default FieldDefListRowItem;
